import React, { useState } from "react";
import InputField from "./InputField";
import { IoIosArrowUp } from "react-icons/io";

const MaternalDetailsForm = ({ formData, handleFormChange }) => {
  const [isOpen, setIsOpen] = useState(true);
  const toggleOpen = () => setIsOpen((prev) => !prev);

  return (
    <div className="w-full border-gray-300 my-4">
      {/* Header with arrow icon */}
      <div
        className="flex flex-row items-center justify-between mb-4 cursor-pointer"
        onClick={toggleOpen}
      >
        <h2 className="text-xl font-semibold mb-2 md:mb-0 relative">
          Maternal Details
        </h2>

        {/* Horizontal Divider with Dots */}
        <div className="relative flex-1 mx-6 h-4">
          {/* The line (centered vertically) */}
          <div className="absolute top-1/2 w-full border-t border-gray-300 -translate-y-1/2" />
          {/* Left Dot */}
          <span className="absolute left-0 top-1/2 -translate-x-1/2 -translate-y-1/2 h-2 w-2 bg-gray-300 rounded-full" />
          {/* Right Dot */}
          <span className="absolute right-0 top-1/2 translate-x-1/2 -translate-y-1/2 h-2 w-2 bg-gray-300 rounded-full" />
        </div>

        <IoIosArrowUp
          size={24}
          className={`transition-transform duration-300 ${isOpen ? "rotate-0" : "rotate-180"}`}
        />
      </div>

      {/* Collapsible Content */}
      <div
        className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? "max-h-[5000px] opacity-100" : "max-h-0 opacity-0"}`}
      >
        <h3 className="text-lg mb-1">Maternal Uncle</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-6 px-1">
          <InputField
            label="Name"
            name="maternal_uncle_name"
            placeholder="Enter Maternal Uncle's Name"
            value={formData.maternal_uncle_name}
            onChange={handleFormChange}
          />
          <InputField
            label="Native Place"
            name="maternal_uncle_native_place"
            placeholder="Enter maternal uncle native place"
            value={formData.maternal_uncle_native_place}
            onChange={handleFormChange}
          />
        </div>
      </div>
    </div>
  );
};

export default MaternalDetailsForm;